/**
 * Header 组件常量定义
 */

/**
 * Cookie 相关常量
 */
export const COOKIE_KEYS = {
  /** 公告横幅关闭 ID */
  ANNOUNCEMENT_BANNER_CLOSED_ID: "announcement_banner_closed_id",
} as const

/**
 * Header 相关常量
 */
export const HEADER_CONSTANTS = {
  /** 语言路径正则 - 匹配 /zh/, /en/ 等语言前缀 */
  LOCALE_PATH_REGEX: /^\/[a-z]{2}(\/|$)/,
  /** 根路径 */
  ROOT_PATH: "/",
} as const

/**
 * 环境变量 keys
 */
export const ENV_KEYS = {
  /** 应用名称 */
  APP_NAME: "NEXT_PUBLIC_NAME",
  /** www 应用标识 */
  WWW_APP_NAME: "www",
} as const
